let app;
switch (process.env.THEME) {
    case 'default':
        app = import('./default');
        break;

    case 'tr106':
        app = import('./tr106');
        break;

    case 'plinkozoobet':
        app = import('./plinkozoobet');
        break;

    default: // TODO: make it 'default'
        app = import('./default');
        break;
}

export default app;
